import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import PictureAsElsIcon from '@mui/icons-material/PictureAsEls';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import ExcelExportIcon from '@mui/icons-material/InsertDriveFile'; // Replace with the desired Excel icon

import SaveIcon from '@mui/icons-material/Save';
import EditAttributesIcon from '@mui/icons-material/EditAttributes';
import { FaFileExcel } from 'react-icons/fa'; // ייבוא האייקון מ-react-icons
import { handlePrint } from './tableActionsFunctions/handlePrint';
import { handleExportPDF } from './tableActionsFunctions/handleExportPDF';


const TableActions = ({ columns, rows }) => {

  // // פונקציות לדוגמה
  // const handlePrint = (columns, rows) => {
  //   // הוסיפי את הקוד להדפסה כאן
  //   // console.log(columns, rows);

  // };

  // const handleExportPDF = (columns, rows) => {
  //   // הוסיפי את הקוד לייצוא ל-PDF כאן
  //   console.log('handleExportPDF', columns, rows);
  // };

  const handleExportExcel = (columns, rows) => {
    // הוסיפי את הקוד לייצוא לאקסל כאן
    console.log('handleExportExcel', columns, rows);
  };

  const handleBulkEdit = (columns, rows) => {
    // הוסיפי את הקוד לעריכה מרובה כאן
    console.log('handleBulkEdit', columns, rows);
  };

  const handleDuplicate = (columns, rows) => {
    // הוסיפי את הקוד לשכפול כרטיסיה כאן
    console.log('handleDuplicate', columns, rows);
  };

  const handleSave = (columns, rows) => {
    // הוסיפי את הקוד לשמירה כאן
    console.log('handleSave', columns, rows);
  };

  return (
    <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start' }}>
      <Tooltip title="הדפסה">
      <IconButton onClick={() => handlePrint(columns, rows)}>
          <PrintIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="ייצוא ל-PDF">
        <IconButton onClick={() => handleExportPDF(columns, rows)}>
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="ייצוא לאקסל">
        <IconButton onClick={() => handleExportExcel(columns, rows)}>
          <FaFileExcel />
        </IconButton>
      </Tooltip>
      <Tooltip title="עריכה מרובה">
        <IconButton onClick={() => handleBulkEdit(columns, rows)}>
          <EditAttributesIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="שכפול כרטיסיה">
        <IconButton onClick={() => handleDuplicate(columns, rows)}>
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="שמירה">
        <IconButton onClick={() => handleSave(columns, rows)}>
          <SaveIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default TableActions;
